module.exports = __webpack_public_path__ + "static/media/pic_banner2.1cb34995.png";